function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).graphology = e();
}(this, function () {
  "use strict";

  function t(e) {
    return t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    }, t(e);
  }

  function e(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, r(t, e);
  }

  function n(t) {
    return n = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, n(t);
  }

  function r(t, e) {
    return r = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    }, r(t, e);
  }

  function i() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }

  function o(t, e, n) {
    return o = i() ? Reflect.construct : function (t, e, n) {
      var i = [null];
      i.push.apply(i, e);
      var o = new (Function.bind.apply(t, i))();
      return n && r(o, n.prototype), o;
    }, o.apply(null, arguments);
  }

  function a(t) {
    var e = "function" == typeof Map ? new Map() : void 0;
    return a = function a(t) {
      if (null === t || (i = t, -1 === Function.toString.call(i).indexOf("[native code]"))) return t;
      var i;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== e) {
        if (e.has(t)) return e.get(t);
        e.set(t, a);
      }

      function a() {
        return o(t, arguments, n(this).constructor);
      }

      return a.prototype = Object.create(t.prototype, {
        constructor: {
          value: a,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), r(a, t);
    }, a(t);
  }

  function u(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  var c = function c() {
    for (var t = arguments[0], e = 1, n = arguments.length; e < n; e++) {
      if (arguments[e]) for (var r in arguments[e]) {
        t[r] = arguments[e][r];
      }
    }

    return t;
  };

  function s(t, e, n, r) {
    var i = t._nodes.get(e),
        o = null;

    return i ? o = "mixed" === r ? i.out && i.out[n] || i.undirected && i.undirected[n] : "directed" === r ? i.out && i.out[n] : i.undirected && i.undirected[n] : o;
  }

  function d(e) {
    return null !== e && "object" === t(e) && "function" == typeof e.addUndirectedEdgeWithKey && "function" == typeof e.dropNode;
  }

  function h(e) {
    return "object" === t(e) && null !== e && e.constructor === Object;
  }

  function p(t) {
    var e;

    for (e in t) {
      return !1;
    }

    return !0;
  }

  function f(t, e, n) {
    Object.defineProperty(t, e, {
      enumerable: !1,
      configurable: !1,
      writable: !0,
      value: n
    });
  }

  function l(t, e, n) {
    var r = {
      enumerable: !0,
      configurable: !0
    };
    "function" == typeof n ? r.get = n : (r.value = n, r.writable = !1), Object.defineProperty(t, e, r);
  }

  function g(t) {
    return !!h(t) && !(t.attributes && !Array.isArray(t.attributes));
  }

  "function" == typeof Object.assign && (c = Object.assign);
  var y,
      w = {
    exports: {}
  },
      v = "object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) ? Reflect : null,
      b = v && "function" == typeof v.apply ? v.apply : function (t, e, n) {
    return Function.prototype.apply.call(t, e, n);
  };
  y = v && "function" == typeof v.ownKeys ? v.ownKeys : Object.getOwnPropertySymbols ? function (t) {
    return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
  } : function (t) {
    return Object.getOwnPropertyNames(t);
  };

  var m = Number.isNaN || function (t) {
    return t != t;
  };

  function k() {
    k.init.call(this);
  }

  w.exports = k, w.exports.once = function (t, e) {
    return new Promise(function (n, r) {
      function i(n) {
        t.removeListener(e, o), r(n);
      }

      function o() {
        "function" == typeof t.removeListener && t.removeListener("error", i), n([].slice.call(arguments));
      }

      N(t, e, o, {
        once: !0
      }), "error" !== e && function (t, e, n) {
        "function" == typeof t.on && N(t, "error", e, n);
      }(t, i, {
        once: !0
      });
    });
  }, k.EventEmitter = k, k.prototype._events = void 0, k.prototype._eventsCount = 0, k.prototype._maxListeners = void 0;
  var _ = 10;

  function G(t) {
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(t));
  }

  function x(t) {
    return void 0 === t._maxListeners ? k.defaultMaxListeners : t._maxListeners;
  }

  function E(t, e, n, r) {
    var i, o, a, u;
    if (G(n), void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, n.listener ? n.listener : n), o = t._events), a = o[e]), void 0 === a) a = o[e] = n, ++t._eventsCount;else if ("function" == typeof a ? a = o[e] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (i = x(t)) > 0 && a.length > i && !a.warned) {
      a.warned = !0;
      var c = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      c.name = "MaxListenersExceededWarning", c.emitter = t, c.type = e, c.count = a.length, u = c, console && console.warn && console.warn(u);
    }
    return t;
  }

  function A() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }

  function S(t, e, n) {
    var r = {
      fired: !1,
      wrapFn: void 0,
      target: t,
      type: e,
      listener: n
    },
        i = A.bind(r);
    return i.listener = n, r.wrapFn = i, i;
  }

  function D(t, e, n) {
    var r = t._events;
    if (void 0 === r) return [];
    var i = r[e];
    return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (t) {
      for (var e = new Array(t.length), n = 0; n < e.length; ++n) {
        e[n] = t[n].listener || t[n];
      }

      return e;
    }(i) : U(i, i.length);
  }

  function L(t) {
    var e = this._events;

    if (void 0 !== e) {
      var n = e[t];
      if ("function" == typeof n) return 1;
      if (void 0 !== n) return n.length;
    }

    return 0;
  }

  function U(t, e) {
    for (var n = new Array(e), r = 0; r < e; ++r) {
      n[r] = t[r];
    }

    return n;
  }

  function N(t, e, n, r) {
    if ("function" == typeof t.on) r.once ? t.once(e, n) : t.on(e, n);else {
      if ("function" != typeof t.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + _typeof(t));
      t.addEventListener(e, function i(o) {
        r.once && t.removeEventListener(e, i), n(o);
      });
    }
  }

  function j(t) {
    if ("function" != typeof t) throw new Error("obliterator/iterator: expecting a function!");
    this.next = t;
  }

  Object.defineProperty(k, "defaultMaxListeners", {
    enumerable: !0,
    get: function get() {
      return _;
    },
    set: function set(t) {
      if ("number" != typeof t || t < 0 || m(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
      _ = t;
    }
  }), k.init = function () {
    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, k.prototype.setMaxListeners = function (t) {
    if ("number" != typeof t || t < 0 || m(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
    return this._maxListeners = t, this;
  }, k.prototype.getMaxListeners = function () {
    return x(this);
  }, k.prototype.emit = function (t) {
    for (var e = [], n = 1; n < arguments.length; n++) {
      e.push(arguments[n]);
    }

    var r = "error" === t,
        i = this._events;
    if (void 0 !== i) r = r && void 0 === i.error;else if (!r) return !1;

    if (r) {
      var o;
      if (e.length > 0 && (o = e[0]), o instanceof Error) throw o;
      var a = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
      throw a.context = o, a;
    }

    var u = i[t];
    if (void 0 === u) return !1;
    if ("function" == typeof u) b(u, this, e);else {
      var c = u.length,
          s = U(u, c);

      for (n = 0; n < c; ++n) {
        b(s[n], this, e);
      }
    }
    return !0;
  }, k.prototype.addListener = function (t, e) {
    return E(this, t, e, !1);
  }, k.prototype.on = k.prototype.addListener, k.prototype.prependListener = function (t, e) {
    return E(this, t, e, !0);
  }, k.prototype.once = function (t, e) {
    return G(e), this.on(t, S(this, t, e)), this;
  }, k.prototype.prependOnceListener = function (t, e) {
    return G(e), this.prependListener(t, S(this, t, e)), this;
  }, k.prototype.removeListener = function (t, e) {
    var n, r, i, o, a;
    if (G(e), void 0 === (r = this._events)) return this;
    if (void 0 === (n = r[t])) return this;
    if (n === e || n.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[t], r.removeListener && this.emit("removeListener", t, n.listener || e));else if ("function" != typeof n) {
      for (i = -1, o = n.length - 1; o >= 0; o--) {
        if (n[o] === e || n[o].listener === e) {
          a = n[o].listener, i = o;
          break;
        }
      }

      if (i < 0) return this;
      0 === i ? n.shift() : function (t, e) {
        for (; e + 1 < t.length; e++) {
          t[e] = t[e + 1];
        }

        t.pop();
      }(n, i), 1 === n.length && (r[t] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", t, a || e);
    }
    return this;
  }, k.prototype.off = k.prototype.removeListener, k.prototype.removeAllListeners = function (t) {
    var e, n, r;
    if (void 0 === (n = this._events)) return this;
    if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[t]), this;

    if (0 === arguments.length) {
      var i,
          o = Object.keys(n);

      for (r = 0; r < o.length; ++r) {
        "removeListener" !== (i = o[r]) && this.removeAllListeners(i);
      }

      return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
    }

    if ("function" == typeof (e = n[t])) this.removeListener(t, e);else if (void 0 !== e) for (r = e.length - 1; r >= 0; r--) {
      this.removeListener(t, e[r]);
    }
    return this;
  }, k.prototype.listeners = function (t) {
    return D(this, t, !0);
  }, k.prototype.rawListeners = function (t) {
    return D(this, t, !1);
  }, k.listenerCount = function (t, e) {
    return "function" == typeof t.listenerCount ? t.listenerCount(e) : L.call(t, e);
  }, k.prototype.listenerCount = L, k.prototype.eventNames = function () {
    return this._eventsCount > 0 ? y(this._events) : [];
  }, "undefined" != typeof Symbol && (j.prototype[Symbol.iterator] = function () {
    return this;
  }), j.of = function () {
    var t = arguments,
        e = t.length,
        n = 0;
    return new j(function () {
      return n >= e ? {
        done: !0
      } : {
        done: !1,
        value: t[n++]
      };
    });
  }, j.empty = function () {
    return new j(function () {
      return {
        done: !0
      };
    });
  }, j.fromSequence = function (t) {
    var e = 0,
        n = t.length;
    return new j(function () {
      return e >= n ? {
        done: !0
      } : {
        done: !1,
        value: t[e++]
      };
    });
  }, j.is = function (t) {
    return t instanceof j || "object" == _typeof(t) && null !== t && "function" == typeof t.next;
  };
  var O = j,
      C = {};
  C.ARRAY_BUFFER_SUPPORT = "undefined" != typeof ArrayBuffer, C.SYMBOL_SUPPORT = "undefined" != typeof Symbol;
  var z = O,
      M = C,
      W = M.ARRAY_BUFFER_SUPPORT,
      P = M.SYMBOL_SUPPORT;

  var R = function R(t) {
    var e = function (t) {
      return "string" == typeof t || Array.isArray(t) || W && ArrayBuffer.isView(t) ? z.fromSequence(t) : "object" != _typeof(t) || null === t ? null : P && "function" == typeof t[Symbol.iterator] ? t[Symbol.iterator]() : "function" == typeof t.next ? t : null;
    }(t);

    if (!e) throw new Error("obliterator: target is not iterable nor a valid iterator.");
    return e;
  },
      K = R,
      T = function T(t, e) {
    for (var n, r = arguments.length > 1 ? e : 1 / 0, i = r !== 1 / 0 ? new Array(r) : [], o = 0, a = K(t);;) {
      if (o === r) return i;
      if ((n = a.next()).done) return o !== e && (i.length = o), i;
      i[o++] = n.value;
    }
  },
      B = function (t) {
    function n(e) {
      var n;
      return (n = t.call(this) || this).name = "GraphError", n.message = e, n;
    }

    return e(n, t), n;
  }(a(Error)),
      F = function (t) {
    function n(e) {
      var r;
      return (r = t.call(this, e) || this).name = "InvalidArgumentsGraphError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(u(r), n.prototype.constructor), r;
    }

    return e(n, t), n;
  }(B),
      I = function (t) {
    function n(e) {
      var r;
      return (r = t.call(this, e) || this).name = "NotFoundGraphError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(u(r), n.prototype.constructor), r;
    }

    return e(n, t), n;
  }(B),
      Y = function (t) {
    function n(e) {
      var r;
      return (r = t.call(this, e) || this).name = "UsageGraphError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(u(r), n.prototype.constructor), r;
    }

    return e(n, t), n;
  }(B);

  function q(t, e) {
    this.key = t, this.attributes = e, this.clear();
  }

  function J(t, e) {
    this.key = t, this.attributes = e, this.clear();
  }

  function V(t, e) {
    this.key = t, this.attributes = e, this.clear();
  }

  function H(t, e, n, r, i) {
    this.key = e, this.attributes = i, this.undirected = t, this.source = n, this.target = r;
  }

  q.prototype.clear = function () {
    this.inDegree = 0, this.outDegree = 0, this.undirectedDegree = 0, this.in = {}, this.out = {}, this.undirected = {};
  }, J.prototype.clear = function () {
    this.inDegree = 0, this.outDegree = 0, this.in = {}, this.out = {};
  }, V.prototype.clear = function () {
    this.undirectedDegree = 0, this.undirected = {};
  }, H.prototype.attach = function () {
    var t = "out",
        e = "in";
    this.undirected && (t = e = "undirected");
    var n = this.source.key,
        r = this.target.key;
    this.source[t][r] = this, this.undirected && n === r || (this.target[e][n] = this);
  }, H.prototype.attachMulti = function () {
    var t = "out",
        e = "in",
        n = this.source.key,
        r = this.target.key;
    this.undirected && (t = e = "undirected");
    var i = this.source[t],
        o = i[r];
    if (void 0 === o) return i[r] = this, void (this.undirected && n === r || (this.target[e][n] = this));
    o.previous = this, this.next = o, i[r] = this, this.target[e][n] = this;
  }, H.prototype.detach = function () {
    var t = this.source.key,
        e = this.target.key,
        n = "out",
        r = "in";
    this.undirected && (n = r = "undirected"), delete this.source[n][e], delete this.target[r][t];
  }, H.prototype.detachMulti = function () {
    var t = this.source.key,
        e = this.target.key,
        n = "out",
        r = "in";
    this.undirected && (n = r = "undirected"), void 0 === this.previous ? void 0 === this.next ? (delete this.source[n][e], delete this.target[r][t]) : (this.next.previous = void 0, this.source[n][e] = this.next, this.target[r][t] = this.next) : (this.previous.next = this.next, void 0 !== this.next && (this.next.previous = this.previous));
  };

  function Q(t, e, n, r, i, o, a) {
    var u, c, s, d;

    if (r = "" + r, 0 === n) {
      if (!(u = t._nodes.get(r))) throw new I("Graph.".concat(e, ': could not find the "').concat(r, '" node in the graph.'));
      s = i, d = o;
    } else if (3 === n) {
      if (i = "" + i, !(c = t._edges.get(i))) throw new I("Graph.".concat(e, ': could not find the "').concat(i, '" edge in the graph.'));
      var h = c.source.key,
          p = c.target.key;
      if (r === h) u = c.target;else {
        if (r !== p) throw new I("Graph.".concat(e, ': the "').concat(r, '" node is not attached to the "').concat(i, '" edge (').concat(h, ", ").concat(p, ")."));
        u = c.source;
      }
      s = o, d = a;
    } else {
      if (!(c = t._edges.get(r))) throw new I("Graph.".concat(e, ': could not find the "').concat(r, '" edge in the graph.'));
      u = 1 === n ? c.source : c.target, s = i, d = o;
    }

    return [u, s, d];
  }

  var X = [{
    name: function name(t) {
      return "get".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        return a.attributes[u];
      };
    }
  }, {
    name: function name(t) {
      return "get".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        return Q(this, e, n, t, r)[0].attributes;
      };
    }
  }, {
    name: function name(t) {
      return "has".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        return a.attributes.hasOwnProperty(u);
      };
    }
  }, {
    name: function name(t) {
      return "set".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i, o) {
        var a = Q(this, e, n, t, r, i, o),
            u = a[0],
            c = a[1],
            s = a[2];
        return u.attributes[c] = s, this.emit("nodeAttributesUpdated", {
          key: u.key,
          type: "set",
          attributes: u.attributes,
          name: c
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "update".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i, o) {
        var a = Q(this, e, n, t, r, i, o),
            u = a[0],
            c = a[1],
            s = a[2];
        if ("function" != typeof s) throw new F("Graph.".concat(e, ": updater should be a function."));
        var d = u.attributes,
            h = s(d[c]);
        return d[c] = h, this.emit("nodeAttributesUpdated", {
          key: u.key,
          type: "set",
          attributes: u.attributes,
          name: c
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "remove".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        return delete a.attributes[u], this.emit("nodeAttributesUpdated", {
          key: a.key,
          type: "remove",
          attributes: a.attributes,
          name: u
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "replace".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        if (!h(u)) throw new F("Graph.".concat(e, ": provided attributes are not a plain object."));
        return a.attributes = u, this.emit("nodeAttributesUpdated", {
          key: a.key,
          type: "replace",
          attributes: a.attributes
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "merge".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        if (!h(u)) throw new F("Graph.".concat(e, ": provided attributes are not a plain object."));
        return c(a.attributes, u), this.emit("nodeAttributesUpdated", {
          key: a.key,
          type: "merge",
          attributes: a.attributes,
          data: u
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "update".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o = Q(this, e, n, t, r, i),
            a = o[0],
            u = o[1];
        if ("function" != typeof u) throw new F("Graph.".concat(e, ": provided updater is not a function."));
        return a.attributes = u(a.attributes), this.emit("nodeAttributesUpdated", {
          key: a.key,
          type: "update",
          attributes: a.attributes
        }), this;
      };
    }
  }];
  var Z = [{
    name: function name(t) {
      return "get".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        return i.attributes[r];
      };
    }
  }, {
    name: function name(t) {
      return "get".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t) {
        var r;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 1) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var i = "" + t,
              o = "" + arguments[1];
          if (!(r = s(this, i, o, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(i, '" - "').concat(o, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(r = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        return r.attributes;
      };
    }
  }, {
    name: function name(t) {
      return "has".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        return i.attributes.hasOwnProperty(r);
      };
    }
  }, {
    name: function name(t) {
      return "set".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 3) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var a = "" + t,
              u = "" + r;
          if (r = arguments[2], i = arguments[3], !(o = s(this, a, u, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(a, '" - "').concat(u, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(o = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        return o.attributes[r] = i, this.emit("edgeAttributesUpdated", {
          key: o.key,
          type: "set",
          attributes: o.attributes,
          name: r
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "update".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r, i) {
        var o;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 3) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var a = "" + t,
              u = "" + r;
          if (r = arguments[2], i = arguments[3], !(o = s(this, a, u, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(a, '" - "').concat(u, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(o = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        if ("function" != typeof i) throw new F("Graph.".concat(e, ": updater should be a function."));
        return o.attributes[r] = i(o.attributes[r]), this.emit("edgeAttributesUpdated", {
          key: o.key,
          type: "set",
          attributes: o.attributes,
          name: r
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "remove".concat(t, "Attribute");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        return delete i.attributes[r], this.emit("edgeAttributesUpdated", {
          key: i.key,
          type: "remove",
          attributes: i.attributes,
          name: r
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "replace".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        if (!h(r)) throw new F("Graph.".concat(e, ": provided attributes are not a plain object."));
        return i.attributes = r, this.emit("edgeAttributesUpdated", {
          key: i.key,
          type: "replace",
          attributes: i.attributes
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "merge".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        if (!h(r)) throw new F("Graph.".concat(e, ": provided attributes are not a plain object."));
        return c(i.attributes, r), this.emit("edgeAttributesUpdated", {
          key: i.key,
          type: "merge",
          attributes: i.attributes,
          data: r
        }), this;
      };
    }
  }, {
    name: function name(t) {
      return "update".concat(t, "Attributes");
    },
    attacher: function attacher(t, e, n) {
      t.prototype[e] = function (t, r) {
        var i;
        if ("mixed" !== this.type && "mixed" !== n && n !== this.type) throw new Y("Graph.".concat(e, ": cannot find this type of edges in your ").concat(this.type, " graph."));

        if (arguments.length > 2) {
          if (this.multi) throw new Y("Graph.".concat(e, ": cannot use a {source,target} combo when asking about an edge's attributes in a MultiGraph since we cannot infer the one you want information about."));
          var o = "" + t,
              a = "" + r;
          if (r = arguments[2], !(i = s(this, o, a, n))) throw new I("Graph.".concat(e, ': could not find an edge for the given path ("').concat(o, '" - "').concat(a, '").'));
        } else {
          if ("mixed" !== n) throw new Y("Graph.".concat(e, ": calling this method with only a key (vs. a source and target) does not make sense since an edge with this key could have the other type."));
          if (t = "" + t, !(i = this._edges.get(t))) throw new I("Graph.".concat(e, ': could not find the "').concat(t, '" edge in the graph.'));
        }

        if ("function" != typeof r) throw new F("Graph.".concat(e, ": provided updater is not a function."));
        return i.attributes = r(i.attributes), this.emit("edgeAttributesUpdated", {
          key: i.key,
          type: "update",
          attributes: i.attributes
        }), this;
      };
    }
  }];

  var $ = O,
      tt = R,
      et = function et() {
    var t = arguments,
        e = null,
        n = -1;
    return new $(function () {
      for (var r = null;;) {
        if (null === e) {
          if (++n >= t.length) return {
            done: !0
          };
          e = tt(t[n]);
        }

        if (!0 !== (r = e.next()).done) break;
        e = null;
      }

      return r;
    });
  },
      nt = [{
    name: "edges",
    type: "mixed"
  }, {
    name: "inEdges",
    type: "directed",
    direction: "in"
  }, {
    name: "outEdges",
    type: "directed",
    direction: "out"
  }, {
    name: "inboundEdges",
    type: "mixed",
    direction: "in"
  }, {
    name: "outboundEdges",
    type: "mixed",
    direction: "out"
  }, {
    name: "directedEdges",
    type: "directed"
  }, {
    name: "undirectedEdges",
    type: "undirected"
  }];

  function rt(t, e, n, r) {
    var i = !1;

    for (var o in e) {
      if (o !== r) {
        var a = e[o];
        if (i = n(a.key, a.attributes, a.source.key, a.target.key, a.source.attributes, a.target.attributes, a.undirected), t && i) return a.key;
      }
    }
  }

  function it(t, e, n, r) {
    var i,
        o,
        a,
        u = !1;

    for (var c in e) {
      if (c !== r) {
        i = e[c];

        do {
          if (o = i.source, a = i.target, u = n(i.key, i.attributes, o.key, a.key, o.attributes, a.attributes, i.undirected), t && u) return i.key;
          i = i.next;
        } while (void 0 !== i);
      }
    }
  }

  function ot(t, e) {
    var n,
        r = Object.keys(t),
        i = r.length,
        o = 0;
    return new O(function () {
      do {
        if (n) n = n.next;else {
          if (o >= i) return {
            done: !0
          };
          var a = r[o++];

          if (a === e) {
            n = void 0;
            continue;
          }

          n = t[a];
        }
      } while (!n);

      return {
        done: !1,
        value: {
          edge: n.key,
          attributes: n.attributes,
          source: n.source.key,
          target: n.target.key,
          sourceAttributes: n.source.attributes,
          targetAttributes: n.target.attributes,
          undirected: n.undirected
        }
      };
    });
  }

  function at(t, e, n, r) {
    var i = e[n];

    if (i) {
      var o = i.source,
          a = i.target;
      return r(i.key, i.attributes, o.key, a.key, o.attributes, a.attributes, i.undirected) && t ? i.key : void 0;
    }
  }

  function ut(t, e, n, r) {
    var i = e[n];

    if (i) {
      var o = !1;

      do {
        if (o = r(i.key, i.attributes, i.source.key, i.target.key, i.source.attributes, i.target.attributes, i.undirected), t && o) return i.key;
        i = i.next;
      } while (void 0 !== i);
    }
  }

  function ct(t, e) {
    var n = t[e];
    return void 0 !== n.next ? new O(function () {
      if (!n) return {
        done: !0
      };
      var t = {
        edge: n.key,
        attributes: n.attributes,
        source: n.source.key,
        target: n.target.key,
        sourceAttributes: n.source.attributes,
        targetAttributes: n.target.attributes,
        undirected: n.undirected
      };
      return n = n.next, {
        done: !1,
        value: t
      };
    }) : O.of({
      edge: n.key,
      attributes: n.attributes,
      source: n.source.key,
      target: n.target.key,
      sourceAttributes: n.source.attributes,
      targetAttributes: n.target.attributes,
      undirected: n.undirected
    });
  }

  function st(t, e) {
    if (0 === t.size) return [];
    if ("mixed" === e || e === t.type) return "function" == typeof Array.from ? Array.from(t._edges.keys()) : T(t._edges.keys(), t._edges.size);

    for (var n, r, i = "undirected" === e ? t.undirectedSize : t.directedSize, o = new Array(i), a = "undirected" === e, u = t._edges.values(), c = 0; !0 !== (n = u.next()).done;) {
      (r = n.value).undirected === a && (o[c++] = r.key);
    }

    return o;
  }

  function dt(t, e, n, r) {
    if (0 !== e.size) for (var i, o, a = "mixed" !== n && n !== e.type, u = "undirected" === n, c = !1, s = e._edges.values(); !0 !== (i = s.next()).done;) {
      if (o = i.value, !a || o.undirected === u) {
        var d = o,
            h = d.key,
            p = d.attributes,
            f = d.source,
            l = d.target;
        if (c = r(h, p, f.key, l.key, f.attributes, l.attributes, o.undirected), t && c) return h;
      }
    }
  }

  function ht(t, e) {
    if (0 === t.size) return O.empty();

    var n = "mixed" !== e && e !== t.type,
        r = "undirected" === e,
        i = t._edges.values();

    return new O(function () {
      for (var t, e;;) {
        if ((t = i.next()).done) return t;
        if (e = t.value, !n || e.undirected === r) break;
      }

      return {
        value: {
          edge: e.key,
          attributes: e.attributes,
          source: e.source.key,
          target: e.target.key,
          sourceAttributes: e.source.attributes,
          targetAttributes: e.target.attributes,
          undirected: e.undirected
        },
        done: !1
      };
    });
  }

  function pt(t, e, n, r, i, o) {
    var a,
        u = e ? it : rt;

    if ("undirected" !== n) {
      if ("out" !== r && (a = u(t, i.in, o), t && a)) return a;
      if ("in" !== r && (a = u(t, i.out, o, r ? void 0 : i.key), t && a)) return a;
    }

    if ("directed" !== n && (a = u(t, i.undirected, o), t && a)) return a;
  }

  function ft(t, e, n, r) {
    var i = [];
    return pt(!1, t, e, n, r, function (t) {
      i.push(t);
    }), i;
  }

  function lt(t, e, n) {
    var r = O.empty();
    return "undirected" !== t && ("out" !== e && void 0 !== n.in && (r = et(r, ot(n.in))), "in" !== e && void 0 !== n.out && (r = et(r, ot(n.out, e ? void 0 : n.key)))), "directed" !== t && void 0 !== n.undirected && (r = et(r, ot(n.undirected))), r;
  }

  function gt(t, e, n, r, i, o, a) {
    var u,
        c = n ? ut : at;

    if ("undirected" !== e) {
      if (void 0 !== i.in && "out" !== r && (u = c(t, i.in, o, a), t && u)) return u;
      if (void 0 !== i.out && "in" !== r && (r || i.key !== o) && (u = c(t, i.out, o, a), t && u)) return u;
    }

    if ("directed" !== e && void 0 !== i.undirected && (u = c(t, i.undirected, o, a), t && u)) return u;
  }

  function yt(t, e, n, r, i) {
    var o = [];
    return gt(!1, t, e, n, r, i, function (t) {
      o.push(t);
    }), o;
  }

  function wt(t, e, n, r) {
    var i = O.empty();
    return "undirected" !== t && (void 0 !== n.in && "out" !== e && r in n.in && (i = et(i, ct(n.in, r))), void 0 !== n.out && "in" !== e && r in n.out && (e || n.key !== r) && (i = et(i, ct(n.out, r)))), "directed" !== t && void 0 !== n.undirected && r in n.undirected && (i = et(i, ct(n.undirected, r))), i;
  }

  var vt = [{
    name: "neighbors",
    type: "mixed"
  }, {
    name: "inNeighbors",
    type: "directed",
    direction: "in"
  }, {
    name: "outNeighbors",
    type: "directed",
    direction: "out"
  }, {
    name: "inboundNeighbors",
    type: "mixed",
    direction: "in"
  }, {
    name: "outboundNeighbors",
    type: "mixed",
    direction: "out"
  }, {
    name: "directedNeighbors",
    type: "directed"
  }, {
    name: "undirectedNeighbors",
    type: "undirected"
  }];

  function bt() {
    this.A = null, this.B = null;
  }

  function mt(t, e, n, r, i) {
    for (var o in r) {
      var a = r[o],
          u = a.source,
          c = a.target,
          s = u === n ? c : u;

      if (!e || !e.has(s.key)) {
        var d = i(s.key, s.attributes);
        if (t && d) return s.key;
      }
    }
  }

  function kt(t, e, n, r, i) {
    if ("mixed" !== e) {
      if ("undirected" === e) return mt(t, null, r, r.undirected, i);
      if ("string" == typeof n) return mt(t, null, r, r[n], i);
    }

    var o,
        a = new bt();

    if ("undirected" !== e) {
      if ("out" !== n) {
        if (o = mt(t, null, r, r.in, i), t && o) return o;
        a.wrap(r.in);
      }

      if ("in" !== n) {
        if (o = mt(t, a, r, r.out, i), t && o) return o;
        a.wrap(r.out);
      }
    }

    if ("directed" !== e && (o = mt(t, a, r, r.undirected, i), t && o)) return o;
  }

  function _t(t, e, n) {
    var r = Object.keys(n),
        i = r.length,
        o = 0;
    return new O(function () {
      var a = null;

      do {
        if (o >= i) return t && t.wrap(n), {
          done: !0
        };
        var u = n[r[o++]],
            c = u.source,
            s = u.target;
        a = c === e ? s : c, t && t.has(a.key) && (a = null);
      } while (null === a);

      return {
        done: !1,
        value: {
          neighbor: a.key,
          attributes: a.attributes
        }
      };
    });
  }

  function Gt(t, e) {
    var n = e.name,
        r = e.type,
        i = e.direction;

    t.prototype[n] = function (t) {
      if ("mixed" !== r && "mixed" !== this.type && r !== this.type) return [];
      t = "" + t;

      var e = this._nodes.get(t);

      if (void 0 === e) throw new I("Graph.".concat(n, ': could not find the "').concat(t, '" node in the graph.'));
      return function (t, e, n) {
        if ("mixed" !== t) {
          if ("undirected" === t) return Object.keys(n.undirected);
          if ("string" == typeof e) return Object.keys(n[e]);
        }

        var r = [];
        return kt(!1, t, e, n, function (t) {
          r.push(t);
        }), r;
      }("mixed" === r ? this.type : r, i, e);
    };
  }

  function xt(t, e) {
    var n = e.name,
        r = e.type,
        i = e.direction,
        o = n.slice(0, -1) + "Entries";

    t.prototype[o] = function (t) {
      if ("mixed" !== r && "mixed" !== this.type && r !== this.type) return O.empty();
      t = "" + t;

      var e = this._nodes.get(t);

      if (void 0 === e) throw new I("Graph.".concat(o, ': could not find the "').concat(t, '" node in the graph.'));
      return function (t, e, n) {
        if ("mixed" !== t) {
          if ("undirected" === t) return _t(null, n, n.undirected);
          if ("string" == typeof e) return _t(null, n, n[e]);
        }

        var r = O.empty(),
            i = new bt();
        return "undirected" !== t && ("out" !== e && (r = et(r, _t(i, n, n.in))), "in" !== e && (r = et(r, _t(i, n, n.out)))), "directed" !== t && (r = et(r, _t(i, n, n.undirected))), r;
      }("mixed" === r ? this.type : r, i, e);
    };
  }

  function Et(t, e, n, r, i) {
    for (var o, a, u, c, s, d, h, p = r._nodes.values(), f = r.type; !0 !== (o = p.next()).done;) {
      var l = !1;
      if (a = o.value, "undirected" !== f) for (u in c = a.out) {
        s = c[u];

        do {
          if (d = s.target, l = !0, h = i(a.key, d.key, a.attributes, d.attributes, s.key, s.attributes, s.undirected), t && h) return s;
          s = s.next;
        } while (s);
      }
      if ("directed" !== f) for (u in c = a.undirected) {
        if (!(e && a.key > u)) {
          s = c[u];

          do {
            if ((d = s.target).key !== u && (d = s.source), l = !0, h = i(a.key, d.key, a.attributes, d.attributes, s.key, s.attributes, s.undirected), t && h) return s;
            s = s.next;
          } while (s);
        }
      }
      if (n && !l && (h = i(a.key, null, a.attributes, null, null, null, null), t && h)) return null;
    }
  }

  function At(t) {
    if (!h(t)) throw new F('Graph.import: invalid serialized node. A serialized node should be a plain object with at least a "key" property.');
    if (!("key" in t)) throw new F("Graph.import: serialized node is missing its key.");
    if ("attributes" in t && (!h(t.attributes) || null === t.attributes)) throw new F("Graph.import: invalid attributes. Attributes should be a plain object, null or omitted.");
  }

  function St(t) {
    if (!h(t)) throw new F('Graph.import: invalid serialized edge. A serialized edge should be a plain object with at least a "source" & "target" property.');
    if (!("source" in t)) throw new F("Graph.import: serialized edge is missing its source.");
    if (!("target" in t)) throw new F("Graph.import: serialized edge is missing its target.");
    if ("attributes" in t && (!h(t.attributes) || null === t.attributes)) throw new F("Graph.import: invalid attributes. Attributes should be a plain object, null or omitted.");
    if ("undirected" in t && "boolean" != typeof t.undirected) throw new F("Graph.import: invalid undirectedness information. Undirected should be boolean or omitted.");
  }

  bt.prototype.wrap = function (t) {
    null === this.A ? this.A = t : null === this.B && (this.B = t);
  }, bt.prototype.has = function (t) {
    return null !== this.A && t in this.A || null !== this.B && t in this.B;
  };
  var Dt,
      Lt = (Dt = 255 & Math.floor(256 * Math.random()), function () {
    return Dt++;
  }),
      Ut = new Set(["directed", "undirected", "mixed"]),
      Nt = new Set(["domain", "_events", "_eventsCount", "_maxListeners"]),
      jt = {
    allowSelfLoops: !0,
    multi: !1,
    type: "mixed"
  };

  function Ot(t, e, n) {
    var r = new t.NodeDataClass(e, n);
    return t._nodes.set(e, r), t.emit("nodeAdded", {
      key: e,
      attributes: n
    }), r;
  }

  function Ct(t, e, n, r, i, o, a, u) {
    if (!r && "undirected" === t.type) throw new Y("Graph.".concat(e, ": you cannot add a directed edge to an undirected graph. Use the #.addEdge or #.addUndirectedEdge instead."));
    if (r && "directed" === t.type) throw new Y("Graph.".concat(e, ": you cannot add an undirected edge to a directed graph. Use the #.addEdge or #.addDirectedEdge instead."));
    if (u && !h(u)) throw new F("Graph.".concat(e, ': invalid attributes. Expecting an object but got "').concat(u, '"'));
    if (o = "" + o, a = "" + a, u = u || {}, !t.allowSelfLoops && o === a) throw new Y("Graph.".concat(e, ': source & target are the same ("').concat(o, "\"), thus creating a loop explicitly forbidden by this graph 'allowSelfLoops' option set to false."));

    var c = t._nodes.get(o),
        s = t._nodes.get(a);

    if (!c) throw new I("Graph.".concat(e, ': source node "').concat(o, '" not found.'));
    if (!s) throw new I("Graph.".concat(e, ': target node "').concat(a, '" not found.'));
    var d = {
      key: null,
      undirected: r,
      source: o,
      target: a,
      attributes: u
    };
    if (n) i = t._edgeKeyGenerator();else if (i = "" + i, t._edges.has(i)) throw new Y("Graph.".concat(e, ': the "').concat(i, '" edge already exists in the graph.'));
    if (!t.multi && (r ? void 0 !== c.undirected[a] : void 0 !== c.out[a])) throw new Y("Graph.".concat(e, ': an edge linking "').concat(o, '" to "').concat(a, "\" already exists. If you really want to add multiple edges linking those nodes, you should create a multi graph by using the 'multi' option."));
    var p = new H(r, i, c, s, u);

    t._edges.set(i, p);

    var f = o === a;
    return r ? (c.undirectedDegree++, s.undirectedDegree++, f && t._undirectedSelfLoopCount++) : (c.outDegree++, s.inDegree++, f && t._directedSelfLoopCount++), t.multi ? p.attachMulti() : p.attach(), r ? t._undirectedSize++ : t._directedSize++, d.key = i, t.emit("edgeAdded", d), i;
  }

  function zt(t, e, n, r, i, o, a, u, s) {
    if (!r && "undirected" === t.type) throw new Y("Graph.".concat(e, ": you cannot merge/update a directed edge to an undirected graph. Use the #.mergeEdge/#.updateEdge or #.addUndirectedEdge instead."));
    if (r && "directed" === t.type) throw new Y("Graph.".concat(e, ": you cannot merge/update an undirected edge to a directed graph. Use the #.mergeEdge/#.updateEdge or #.addDirectedEdge instead."));
    if (u) if (s) {
      if ("function" != typeof u) throw new F("Graph.".concat(e, ': invalid updater function. Expecting a function but got "').concat(u, '"'));
    } else if (!h(u)) throw new F("Graph.".concat(e, ': invalid attributes. Expecting an object but got "').concat(u, '"'));
    var d;
    if (o = "" + o, a = "" + a, s && (d = u, u = void 0), !t.allowSelfLoops && o === a) throw new Y("Graph.".concat(e, ': source & target are the same ("').concat(o, "\"), thus creating a loop explicitly forbidden by this graph 'allowSelfLoops' option set to false."));

    var p,
        f,
        l = t._nodes.get(o),
        g = t._nodes.get(a);

    if (!n && (p = t._edges.get(i))) {
      if (!(p.source.key === o && p.target.key === a || r && p.source.key === a && p.target.key === o)) throw new Y("Graph.".concat(e, ': inconsistency detected when attempting to merge the "').concat(i, '" edge with "').concat(o, '" source & "').concat(a, '" target vs. ("').concat(p.source.key, '", "').concat(p.target.key, '").'));
      f = p;
    }

    if (f || t.multi || !l || (f = r ? l.undirected[a] : l.out[a]), f) {
      var y = [f.key, !1, !1, !1];
      if (s ? !d : !u) return y;

      if (s) {
        var w = f.attributes;
        f.attributes = d(w), t.emit("edgeAttributesUpdated", {
          type: "replace",
          key: f.key,
          attributes: f.attributes
        });
      } else c(f.attributes, u), t.emit("edgeAttributesUpdated", {
        type: "merge",
        key: f.key,
        attributes: f.attributes,
        data: u
      });

      return y;
    }

    u = u || {}, s && d && (u = d(u));
    var v = {
      key: null,
      undirected: r,
      source: o,
      target: a,
      attributes: u
    };
    if (n) i = t._edgeKeyGenerator();else if (i = "" + i, t._edges.has(i)) throw new Y("Graph.".concat(e, ': the "').concat(i, '" edge already exists in the graph.'));
    var b = !1,
        m = !1;
    l || (l = Ot(t, o, {}), b = !0, o === a && (g = l, m = !0)), g || (g = Ot(t, a, {}), m = !0), p = new H(r, i, l, g, u), t._edges.set(i, p);
    var k = o === a;
    return r ? (l.undirectedDegree++, g.undirectedDegree++, k && t._undirectedSelfLoopCount++) : (l.outDegree++, g.inDegree++, k && t._directedSelfLoopCount++), t.multi ? p.attachMulti() : p.attach(), r ? t._undirectedSize++ : t._directedSize++, v.key = i, t.emit("edgeAdded", v), [i, !0, b, m];
  }

  function Mt(t, e) {
    t._edges.delete(e.key);

    var n = e.source,
        r = e.target,
        i = e.attributes,
        o = e.undirected,
        a = n === r;
    o ? (n.undirectedDegree--, r.undirectedDegree--, a && t._undirectedSelfLoopCount--) : (n.outDegree--, r.inDegree--, a && t._directedSelfLoopCount--), t.multi ? e.detachMulti() : e.detach(), o ? t._undirectedSize-- : t._directedSize--, t.emit("edgeDropped", {
      key: e.key,
      attributes: i,
      source: n.key,
      target: r.key,
      undirected: o
    });
  }

  var Wt = function (n) {
    function r(t) {
      var e;
      if (e = n.call(this) || this, "boolean" != typeof (t = c({}, jt, t)).multi) throw new F("Graph.constructor: invalid 'multi' option. Expecting a boolean but got \"".concat(t.multi, '".'));
      if (!Ut.has(t.type)) throw new F('Graph.constructor: invalid \'type\' option. Should be one of "mixed", "directed" or "undirected" but got "'.concat(t.type, '".'));
      if ("boolean" != typeof t.allowSelfLoops) throw new F("Graph.constructor: invalid 'allowSelfLoops' option. Expecting a boolean but got \"".concat(t.allowSelfLoops, '".'));
      var r = "mixed" === t.type ? q : "directed" === t.type ? J : V;
      f(u(e), "NodeDataClass", r);
      var i = "geid_" + Lt() + "_",
          o = 0;
      return f(u(e), "_attributes", {}), f(u(e), "_nodes", new Map()), f(u(e), "_edges", new Map()), f(u(e), "_directedSize", 0), f(u(e), "_undirectedSize", 0), f(u(e), "_directedSelfLoopCount", 0), f(u(e), "_undirectedSelfLoopCount", 0), f(u(e), "_edgeKeyGenerator", function () {
        var t;

        do {
          t = i + o++;
        } while (e._edges.has(t));

        return t;
      }), f(u(e), "_options", t), Nt.forEach(function (t) {
        return f(u(e), t, e[t]);
      }), l(u(e), "order", function () {
        return e._nodes.size;
      }), l(u(e), "size", function () {
        return e._edges.size;
      }), l(u(e), "directedSize", function () {
        return e._directedSize;
      }), l(u(e), "undirectedSize", function () {
        return e._undirectedSize;
      }), l(u(e), "selfLoopCount", function () {
        return e._directedSelfLoopCount + e._undirectedSelfLoopCount;
      }), l(u(e), "directedSelfLoopCount", function () {
        return e._directedSelfLoopCount;
      }), l(u(e), "undirectedSelfLoopCount", function () {
        return e._undirectedSelfLoopCount;
      }), l(u(e), "multi", e._options.multi), l(u(e), "type", e._options.type), l(u(e), "allowSelfLoops", e._options.allowSelfLoops), l(u(e), "implementation", function () {
        return "graphology";
      }), e;
    }

    e(r, n);
    var i = r.prototype;
    return i._resetInstanceCounters = function () {
      this._directedSize = 0, this._undirectedSize = 0, this._directedSelfLoopCount = 0, this._undirectedSelfLoopCount = 0;
    }, i.hasNode = function (t) {
      return this._nodes.has("" + t);
    }, i.hasDirectedEdge = function (t, e) {
      if ("undirected" === this.type) return !1;

      if (1 === arguments.length) {
        var n = "" + t,
            r = this._edges.get(n);

        return !!r && !r.undirected;
      }

      if (2 === arguments.length) {
        t = "" + t, e = "" + e;

        var i = this._nodes.get(t);

        if (!i) return !1;
        var o = i.out[e];
        return !!o && (!this.multi || !!o.size);
      }

      throw new F("Graph.hasDirectedEdge: invalid arity (".concat(arguments.length, ", instead of 1 or 2). You can either ask for an edge id or for the existence of an edge between a source & a target."));
    }, i.hasUndirectedEdge = function (t, e) {
      if ("directed" === this.type) return !1;

      if (1 === arguments.length) {
        var n = "" + t,
            r = this._edges.get(n);

        return !!r && r.undirected;
      }

      if (2 === arguments.length) {
        t = "" + t, e = "" + e;

        var i = this._nodes.get(t);

        if (!i) return !1;
        var o = i.undirected[e];
        return !!o && (!this.multi || !!o.size);
      }

      throw new F("Graph.hasDirectedEdge: invalid arity (".concat(arguments.length, ", instead of 1 or 2). You can either ask for an edge id or for the existence of an edge between a source & a target."));
    }, i.hasEdge = function (t, e) {
      if (1 === arguments.length) {
        var n = "" + t;
        return this._edges.has(n);
      }

      if (2 === arguments.length) {
        t = "" + t, e = "" + e;

        var r = this._nodes.get(t);

        if (!r) return !1;
        var i = void 0 !== r.out && r.out[e];
        return i || (i = void 0 !== r.undirected && r.undirected[e]), !!i && (!this.multi || !!i.size);
      }

      throw new F("Graph.hasEdge: invalid arity (".concat(arguments.length, ", instead of 1 or 2). You can either ask for an edge id or for the existence of an edge between a source & a target."));
    }, i.directedEdge = function (t, e) {
      if ("undirected" !== this.type) {
        if (t = "" + t, e = "" + e, this.multi) throw new Y("Graph.directedEdge: this method is irrelevant with multigraphs since there might be multiple edges between source & target. See #.directedEdges instead.");

        var n = this._nodes.get(t);

        if (!n) throw new I('Graph.directedEdge: could not find the "'.concat(t, '" source node in the graph.'));
        if (!this._nodes.has(e)) throw new I('Graph.directedEdge: could not find the "'.concat(e, '" target node in the graph.'));
        var r = n.out && n.out[e] || void 0;
        return r ? r.key : void 0;
      }
    }, i.undirectedEdge = function (t, e) {
      if ("directed" !== this.type) {
        if (t = "" + t, e = "" + e, this.multi) throw new Y("Graph.undirectedEdge: this method is irrelevant with multigraphs since there might be multiple edges between source & target. See #.undirectedEdges instead.");

        var n = this._nodes.get(t);

        if (!n) throw new I('Graph.undirectedEdge: could not find the "'.concat(t, '" source node in the graph.'));
        if (!this._nodes.has(e)) throw new I('Graph.undirectedEdge: could not find the "'.concat(e, '" target node in the graph.'));
        var r = n.undirected && n.undirected[e] || void 0;
        return r ? r.key : void 0;
      }
    }, i.edge = function (t, e) {
      if (this.multi) throw new Y("Graph.edge: this method is irrelevant with multigraphs since there might be multiple edges between source & target. See #.edges instead.");
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.edge: could not find the "'.concat(t, '" source node in the graph.'));
      if (!this._nodes.has(e)) throw new I('Graph.edge: could not find the "'.concat(e, '" target node in the graph.'));
      var r = n.out && n.out[e] || n.undirected && n.undirected[e] || void 0;
      if (r) return r.key;
    }, i.areDirectedNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areDirectedNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && (e in n.in || e in n.out);
    }, i.areOutNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areOutNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && e in n.out;
    }, i.areInNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areInNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && e in n.in;
    }, i.areUndirectedNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areUndirectedNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "directed" !== this.type && e in n.undirected;
    }, i.areNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && (e in n.in || e in n.out) || "directed" !== this.type && e in n.undirected;
    }, i.areInboundNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areInboundNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && e in n.in || "directed" !== this.type && e in n.undirected;
    }, i.areOutboundNeighbors = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._nodes.get(t);

      if (!n) throw new I('Graph.areOutboundNeighbors: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" !== this.type && e in n.out || "directed" !== this.type && e in n.undirected;
    }, i.inDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.inDegree: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" === this.type ? 0 : e.inDegree;
    }, i.outDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.outDegree: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" === this.type ? 0 : e.outDegree;
    }, i.directedDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.directedDegree: could not find the "'.concat(t, '" node in the graph.'));
      return "undirected" === this.type ? 0 : e.inDegree + e.outDegree;
    }, i.undirectedDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.undirectedDegree: could not find the "'.concat(t, '" node in the graph.'));
      return "directed" === this.type ? 0 : e.undirectedDegree;
    }, i.inboundDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.inboundDegree: could not find the "'.concat(t, '" node in the graph.'));
      var n = 0;
      return "directed" !== this.type && (n += e.undirectedDegree), "undirected" !== this.type && (n += e.inDegree), n;
    }, i.outboundDegree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.outboundDegree: could not find the "'.concat(t, '" node in the graph.'));
      var n = 0;
      return "directed" !== this.type && (n += e.undirectedDegree), "undirected" !== this.type && (n += e.outDegree), n;
    }, i.degree = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.degree: could not find the "'.concat(t, '" node in the graph.'));
      var n = 0;
      return "directed" !== this.type && (n += e.undirectedDegree), "undirected" !== this.type && (n += e.inDegree + e.outDegree), n;
    }, i.inDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.inDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      if ("undirected" === this.type) return 0;
      var n = e.in[t],
          r = n ? this.multi ? n.size : 1 : 0;
      return e.inDegree - r;
    }, i.outDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.outDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      if ("undirected" === this.type) return 0;
      var n = e.out[t],
          r = n ? this.multi ? n.size : 1 : 0;
      return e.outDegree - r;
    }, i.directedDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.directedDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      if ("undirected" === this.type) return 0;
      var n = e.out[t],
          r = n ? this.multi ? n.size : 1 : 0;
      return e.inDegree + e.outDegree - 2 * r;
    }, i.undirectedDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e = this._nodes.get(t);

      if (!e) throw new I('Graph.undirectedDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      if ("directed" === this.type) return 0;
      var n = e.undirected[t],
          r = n ? this.multi ? n.size : 1 : 0;
      return e.undirectedDegree - 2 * r;
    }, i.inboundDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e,
          n = this._nodes.get(t);

      if (!n) throw new I('Graph.inboundDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      var r = 0,
          i = 0;
      return "directed" !== this.type && (r += n.undirectedDegree, i += 2 * ((e = n.undirected[t]) ? this.multi ? e.size : 1 : 0)), "undirected" !== this.type && (r += n.inDegree, i += (e = n.out[t]) ? this.multi ? e.size : 1 : 0), r - i;
    }, i.outboundDegreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e,
          n = this._nodes.get(t);

      if (!n) throw new I('Graph.outboundDegreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      var r = 0,
          i = 0;
      return "directed" !== this.type && (r += n.undirectedDegree, i += 2 * ((e = n.undirected[t]) ? this.multi ? e.size : 1 : 0)), "undirected" !== this.type && (r += n.outDegree, i += (e = n.in[t]) ? this.multi ? e.size : 1 : 0), r - i;
    }, i.degreeWithoutSelfLoops = function (t) {
      t = "" + t;

      var e,
          n = this._nodes.get(t);

      if (!n) throw new I('Graph.degreeWithoutSelfLoops: could not find the "'.concat(t, '" node in the graph.'));
      var r = 0,
          i = 0;
      return "directed" !== this.type && (r += n.undirectedDegree, i += 2 * ((e = n.undirected[t]) ? this.multi ? e.size : 1 : 0)), "undirected" !== this.type && (r += n.inDegree + n.outDegree, i += 2 * ((e = n.out[t]) ? this.multi ? e.size : 1 : 0)), r - i;
    }, i.source = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.source: could not find the "'.concat(t, '" edge in the graph.'));
      return e.source.key;
    }, i.target = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.target: could not find the "'.concat(t, '" edge in the graph.'));
      return e.target.key;
    }, i.extremities = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.extremities: could not find the "'.concat(t, '" edge in the graph.'));
      return [e.source.key, e.target.key];
    }, i.opposite = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._edges.get(e);

      if (!n) throw new I('Graph.opposite: could not find the "'.concat(e, '" edge in the graph.'));
      var r = n.source.key,
          i = n.target.key;
      if (t === r) return i;
      if (t === i) return r;
      throw new I('Graph.opposite: the "'.concat(t, '" node is not attached to the "').concat(e, '" edge (').concat(r, ", ").concat(i, ")."));
    }, i.hasExtremity = function (t, e) {
      t = "" + t, e = "" + e;

      var n = this._edges.get(t);

      if (!n) throw new I('Graph.hasExtremity: could not find the "'.concat(t, '" edge in the graph.'));
      return n.source.key === e || n.target.key === e;
    }, i.isUndirected = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.isUndirected: could not find the "'.concat(t, '" edge in the graph.'));
      return e.undirected;
    }, i.isDirected = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.isDirected: could not find the "'.concat(t, '" edge in the graph.'));
      return !e.undirected;
    }, i.isSelfLoop = function (t) {
      t = "" + t;

      var e = this._edges.get(t);

      if (!e) throw new I('Graph.isSelfLoop: could not find the "'.concat(t, '" edge in the graph.'));
      return e.source === e.target;
    }, i.addNode = function (t, e) {
      var n = function (t, e, n) {
        if (n && !h(n)) throw new F('Graph.addNode: invalid attributes. Expecting an object but got "'.concat(n, '"'));
        if (e = "" + e, n = n || {}, t._nodes.has(e)) throw new Y('Graph.addNode: the "'.concat(e, '" node already exist in the graph.'));
        var r = new t.NodeDataClass(e, n);
        return t._nodes.set(e, r), t.emit("nodeAdded", {
          key: e,
          attributes: n
        }), r;
      }(this, t, e);

      return n.key;
    }, i.mergeNode = function (t, e) {
      if (e && !h(e)) throw new F('Graph.mergeNode: invalid attributes. Expecting an object but got "'.concat(e, '"'));
      t = "" + t, e = e || {};

      var n = this._nodes.get(t);

      return n ? (e && (c(n.attributes, e), this.emit("nodeAttributesUpdated", {
        type: "merge",
        key: t,
        attributes: n.attributes,
        data: e
      })), [t, !1]) : (n = new this.NodeDataClass(t, e), this._nodes.set(t, n), this.emit("nodeAdded", {
        key: t,
        attributes: e
      }), [t, !0]);
    }, i.updateNode = function (t, e) {
      if (e && "function" != typeof e) throw new F('Graph.updateNode: invalid updater function. Expecting a function but got "'.concat(e, '"'));
      t = "" + t;

      var n = this._nodes.get(t);

      if (n) {
        if (e) {
          var r = n.attributes;
          n.attributes = e(r), this.emit("nodeAttributesUpdated", {
            type: "replace",
            key: t,
            attributes: n.attributes
          });
        }

        return [t, !1];
      }

      var i = e ? e({}) : {};
      return n = new this.NodeDataClass(t, i), this._nodes.set(t, n), this.emit("nodeAdded", {
        key: t,
        attributes: i
      }), [t, !0];
    }, i.dropNode = function (t) {
      t = "" + t;

      var e,
          n = this._nodes.get(t);

      if (!n) throw new I('Graph.dropNode: could not find the "'.concat(t, '" node in the graph.'));

      if ("undirected" !== this.type) {
        for (var r in n.out) {
          e = n.out[r];

          do {
            Mt(this, e), e = e.next;
          } while (e);
        }

        for (var i in n.in) {
          e = n.in[i];

          do {
            Mt(this, e), e = e.next;
          } while (e);
        }
      }

      if ("directed" !== this.type) for (var o in n.undirected) {
        e = n.undirected[o];

        do {
          Mt(this, e), e = e.next;
        } while (e);
      }
      this._nodes.delete(t), this.emit("nodeDropped", {
        key: t,
        attributes: n.attributes
      });
    }, i.dropEdge = function (t) {
      var e;

      if (arguments.length > 1) {
        var n = "" + arguments[0],
            r = "" + arguments[1];
        if (!(e = s(this, n, r, this.type))) throw new I('Graph.dropEdge: could not find the "'.concat(n, '" -> "').concat(r, '" edge in the graph.'));
      } else if (t = "" + t, !(e = this._edges.get(t))) throw new I('Graph.dropEdge: could not find the "'.concat(t, '" edge in the graph.'));

      return Mt(this, e), this;
    }, i.dropDirectedEdge = function (t, e) {
      if (arguments.length < 2) throw new Y("Graph.dropDirectedEdge: it does not make sense to try and drop a directed edge by key. What if the edge with this key is undirected? Use #.dropEdge for this purpose instead.");
      if (this.multi) throw new Y("Graph.dropDirectedEdge: cannot use a {source,target} combo when dropping an edge in a MultiGraph since we cannot infer the one you want to delete as there could be multiple ones.");
      var n = s(this, t = "" + t, e = "" + e, "directed");
      if (!n) throw new I('Graph.dropDirectedEdge: could not find a "'.concat(t, '" -> "').concat(e, '" edge in the graph.'));
      return Mt(this, n), this;
    }, i.dropUndirectedEdge = function (t, e) {
      if (arguments.length < 2) throw new Y("Graph.dropUndirectedEdge: it does not make sense to drop a directed edge by key. What if the edge with this key is undirected? Use #.dropEdge for this purpose instead.");
      if (this.multi) throw new Y("Graph.dropUndirectedEdge: cannot use a {source,target} combo when dropping an edge in a MultiGraph since we cannot infer the one you want to delete as there could be multiple ones.");
      var n = s(this, t, e, "undirected");
      if (!n) throw new I('Graph.dropUndirectedEdge: could not find a "'.concat(t, '" -> "').concat(e, '" edge in the graph.'));
      return Mt(this, n), this;
    }, i.clear = function () {
      this._edges.clear(), this._nodes.clear(), this._resetInstanceCounters(), this.emit("cleared");
    }, i.clearEdges = function () {
      for (var t, e = this._nodes.values(); !0 !== (t = e.next()).done;) {
        t.value.clear();
      }

      this._edges.clear(), this._resetInstanceCounters(), this.emit("edgesCleared");
    }, i.getAttribute = function (t) {
      return this._attributes[t];
    }, i.getAttributes = function () {
      return this._attributes;
    }, i.hasAttribute = function (t) {
      return this._attributes.hasOwnProperty(t);
    }, i.setAttribute = function (t, e) {
      return this._attributes[t] = e, this.emit("attributesUpdated", {
        type: "set",
        attributes: this._attributes,
        name: t
      }), this;
    }, i.updateAttribute = function (t, e) {
      if ("function" != typeof e) throw new F("Graph.updateAttribute: updater should be a function.");
      var n = this._attributes[t];
      return this._attributes[t] = e(n), this.emit("attributesUpdated", {
        type: "set",
        attributes: this._attributes,
        name: t
      }), this;
    }, i.removeAttribute = function (t) {
      return delete this._attributes[t], this.emit("attributesUpdated", {
        type: "remove",
        attributes: this._attributes,
        name: t
      }), this;
    }, i.replaceAttributes = function (t) {
      if (!h(t)) throw new F("Graph.replaceAttributes: provided attributes are not a plain object.");
      return this._attributes = t, this.emit("attributesUpdated", {
        type: "replace",
        attributes: this._attributes
      }), this;
    }, i.mergeAttributes = function (t) {
      if (!h(t)) throw new F("Graph.mergeAttributes: provided attributes are not a plain object.");
      return c(this._attributes, t), this.emit("attributesUpdated", {
        type: "merge",
        attributes: this._attributes,
        data: t
      }), this;
    }, i.updateAttributes = function (t) {
      if ("function" != typeof t) throw new F("Graph.updateAttributes: provided updater is not a function.");
      return this._attributes = t(this._attributes), this.emit("attributesUpdated", {
        type: "update",
        attributes: this._attributes
      }), this;
    }, i.updateEachNodeAttributes = function (t, e) {
      if ("function" != typeof t) throw new F("Graph.updateEachNodeAttributes: expecting an updater function.");
      if (e && !g(e)) throw new F("Graph.updateEachNodeAttributes: invalid hints. Expecting an object having the following shape: {attributes?: [string]}");

      for (var n, r, i = this._nodes.values(); !0 !== (n = i.next()).done;) {
        (r = n.value).attributes = t(r.key, r.attributes);
      }

      this.emit("eachNodeAttributesUpdated", {
        hints: e || null
      });
    }, i.updateEachEdgeAttributes = function (t, e) {
      if ("function" != typeof t) throw new F("Graph.updateEachEdgeAttributes: expecting an updater function.");
      if (e && !g(e)) throw new F("Graph.updateEachEdgeAttributes: invalid hints. Expecting an object having the following shape: {attributes?: [string]}");

      for (var n, r, i, o, a = this._edges.values(); !0 !== (n = a.next()).done;) {
        i = (r = n.value).source, o = r.target, r.attributes = t(r.key, r.attributes, i.key, o.key, i.attributes, o.attributes, r.undirected);
      }

      this.emit("eachEdgeAttributesUpdated", {
        hints: e || null
      });
    }, i.forEachAdjacencyEntry = function (t) {
      if ("function" != typeof t) throw new F("Graph.forEachAdjacencyEntry: expecting a callback.");
      Et(!1, !1, !1, this, t);
    }, i.forEachAdjacencyEntryWithOrphans = function (t) {
      if ("function" != typeof t) throw new F("Graph.forEachAdjacencyEntryWithOrphans: expecting a callback.");
      Et(!1, !1, !0, this, t);
    }, i.forEachAssymetricAdjacencyEntry = function (t) {
      if ("function" != typeof t) throw new F("Graph.forEachAssymetricAdjacencyEntry: expecting a callback.");
      Et(!1, !0, !1, this, t);
    }, i.forEachAssymetricAdjacencyEntryWithOrphans = function (t) {
      if ("function" != typeof t) throw new F("Graph.forEachAssymetricAdjacencyEntryWithOrphans: expecting a callback.");
      Et(!1, !0, !0, this, t);
    }, i.nodes = function () {
      return "function" == typeof Array.from ? Array.from(this._nodes.keys()) : T(this._nodes.keys(), this._nodes.size);
    }, i.forEachNode = function (t) {
      if ("function" != typeof t) throw new F("Graph.forEachNode: expecting a callback.");

      for (var e, n, r = this._nodes.values(); !0 !== (e = r.next()).done;) {
        t((n = e.value).key, n.attributes);
      }
    }, i.findNode = function (t) {
      if ("function" != typeof t) throw new F("Graph.findNode: expecting a callback.");

      for (var e, n, r = this._nodes.values(); !0 !== (e = r.next()).done;) {
        if (t((n = e.value).key, n.attributes)) return n.key;
      }
    }, i.mapNodes = function (t) {
      if ("function" != typeof t) throw new F("Graph.mapNode: expecting a callback.");

      for (var e, n, r = this._nodes.values(), i = new Array(this.order), o = 0; !0 !== (e = r.next()).done;) {
        n = e.value, i[o++] = t(n.key, n.attributes);
      }

      return i;
    }, i.someNode = function (t) {
      if ("function" != typeof t) throw new F("Graph.someNode: expecting a callback.");

      for (var e, n, r = this._nodes.values(); !0 !== (e = r.next()).done;) {
        if (t((n = e.value).key, n.attributes)) return !0;
      }

      return !1;
    }, i.everyNode = function (t) {
      if ("function" != typeof t) throw new F("Graph.everyNode: expecting a callback.");

      for (var e, n, r = this._nodes.values(); !0 !== (e = r.next()).done;) {
        if (!t((n = e.value).key, n.attributes)) return !1;
      }

      return !0;
    }, i.filterNodes = function (t) {
      if ("function" != typeof t) throw new F("Graph.filterNodes: expecting a callback.");

      for (var e, n, r = this._nodes.values(), i = []; !0 !== (e = r.next()).done;) {
        t((n = e.value).key, n.attributes) && i.push(n.key);
      }

      return i;
    }, i.reduceNodes = function (t, e) {
      if ("function" != typeof t) throw new F("Graph.reduceNodes: expecting a callback.");
      if (arguments.length < 2) throw new F("Graph.reduceNodes: missing initial value. You must provide it because the callback takes more than one argument and we cannot infer the initial value from the first iteration, as you could with a simple array.");

      for (var n, r, i = e, o = this._nodes.values(); !0 !== (n = o.next()).done;) {
        i = t(i, (r = n.value).key, r.attributes);
      }

      return i;
    }, i.nodeEntries = function () {
      var t = this._nodes.values();

      return new O(function () {
        var e = t.next();
        if (e.done) return e;
        var n = e.value;
        return {
          value: {
            node: n.key,
            attributes: n.attributes
          },
          done: !1
        };
      });
    }, i.export = function () {
      var t = new Array(this._nodes.size),
          e = 0;

      this._nodes.forEach(function (n, r) {
        t[e++] = function (t, e) {
          var n = {
            key: t
          };
          return p(e.attributes) || (n.attributes = c({}, e.attributes)), n;
        }(r, n);
      });

      var n = new Array(this._edges.size);
      return e = 0, this._edges.forEach(function (t, r) {
        n[e++] = function (t, e) {
          var n = {
            key: t,
            source: e.source.key,
            target: e.target.key
          };
          return p(e.attributes) || (n.attributes = c({}, e.attributes)), e.undirected && (n.undirected = !0), n;
        }(r, t);
      }), {
        options: {
          type: this.type,
          multi: this.multi,
          allowSelfLoops: this.allowSelfLoops
        },
        attributes: this.getAttributes(),
        nodes: t,
        edges: n
      };
    }, i.import = function (t) {
      var e,
          n,
          r,
          i,
          o,
          a = this,
          u = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      if (d(t)) return t.forEachNode(function (t, e) {
        u ? a.mergeNode(t, e) : a.addNode(t, e);
      }), t.forEachEdge(function (t, e, n, r, i, o, c) {
        u ? c ? a.mergeUndirectedEdgeWithKey(t, n, r, e) : a.mergeDirectedEdgeWithKey(t, n, r, e) : c ? a.addUndirectedEdgeWithKey(t, n, r, e) : a.addDirectedEdgeWithKey(t, n, r, e);
      }), this;
      if (!h(t)) throw new F("Graph.import: invalid argument. Expecting a serialized graph or, alternatively, a Graph instance.");

      if (t.attributes) {
        if (!h(t.attributes)) throw new F("Graph.import: invalid attributes. Expecting a plain object.");
        u ? this.mergeAttributes(t.attributes) : this.replaceAttributes(t.attributes);
      }

      if (t.nodes) {
        if (r = t.nodes, !Array.isArray(r)) throw new F("Graph.import: invalid nodes. Expecting an array.");

        for (e = 0, n = r.length; e < n; e++) {
          At(i = r[e]);
          var c = i,
              s = c.key,
              p = c.attributes;
          u ? this.mergeNode(s, p) : this.addNode(s, p);
        }
      }

      if (t.edges) {
        if (r = t.edges, !Array.isArray(r)) throw new F("Graph.import: invalid edges. Expecting an array.");

        for (e = 0, n = r.length; e < n; e++) {
          St(o = r[e]);
          var f = o,
              l = f.source,
              g = f.target,
              y = f.attributes,
              w = f.undirected,
              v = void 0 !== w && w;
          "key" in o ? (u ? v ? this.mergeUndirectedEdgeWithKey : this.mergeDirectedEdgeWithKey : v ? this.addUndirectedEdgeWithKey : this.addDirectedEdgeWithKey).call(this, o.key, l, g, y) : (u ? v ? this.mergeUndirectedEdge : this.mergeDirectedEdge : v ? this.addUndirectedEdge : this.addDirectedEdge).call(this, l, g, y);
        }
      }

      return this;
    }, i.nullCopy = function (t) {
      var e = new r(c({}, this._options, t));
      return e.replaceAttributes(c({}, this.getAttributes())), e;
    }, i.emptyCopy = function (t) {
      var e = this.nullCopy(t);
      return this._nodes.forEach(function (t, n) {
        var r = c({}, t.attributes);
        t = new e.NodeDataClass(n, r), e._nodes.set(n, t);
      }), e;
    }, i.copy = function (t) {
      if ("string" == typeof (t = t || {}).type && t.type !== this.type && "mixed" !== t.type) throw new Y('Graph.copy: cannot create an incompatible copy from "'.concat(this.type, '" type to "').concat(t.type, '" because this would mean losing information about the current graph.'));
      if ("boolean" == typeof t.multi && t.multi !== this.multi && !0 !== t.multi) throw new Y("Graph.copy: cannot create an incompatible copy by downgrading a multi graph to a simple one because this would mean losing information about the current graph.");
      if ("boolean" == typeof t.allowSelfLoops && t.allowSelfLoops !== this.allowSelfLoops && !0 !== t.allowSelfLoops) throw new Y("Graph.copy: cannot create an incompatible copy from a graph allowing self loops to one that does not because this would mean losing information about the current graph.");

      for (var e, n, r = this.emptyCopy(t), i = this._edges.values(); !0 !== (e = i.next()).done;) {
        Ct(r, "copy", !1, (n = e.value).undirected, n.key, n.source.key, n.target.key, c({}, n.attributes));
      }

      return r;
    }, i.toJSON = function () {
      return this.export();
    }, i.toString = function () {
      return "[object Graph]";
    }, i.inspect = function () {
      var e = this,
          n = {};

      this._nodes.forEach(function (t, e) {
        n[e] = t.attributes;
      });

      var r = {},
          i = {};

      this._edges.forEach(function (t, n) {
        var o,
            a = t.undirected ? "--" : "->",
            u = "",
            c = t.source.key,
            s = t.target.key;
        t.undirected && c > s && (o = c, c = s, s = o);
        var d = "(".concat(c, ")").concat(a, "(").concat(s, ")");
        n.startsWith("geid_") ? e.multi && (void 0 === i[d] ? i[d] = 0 : i[d]++, u += "".concat(i[d], ". ")) : u += "[".concat(n, "]: "), r[u += d] = t.attributes;
      });

      var o = {};

      for (var a in this) {
        this.hasOwnProperty(a) && !Nt.has(a) && "function" != typeof this[a] && "symbol" !== t(a) && (o[a] = this[a]);
      }

      return o.attributes = this._attributes, o.nodes = n, o.edges = r, f(o, "constructor", this.constructor), o;
    }, r;
  }(w.exports.EventEmitter);

  "undefined" != typeof Symbol && (Wt.prototype[Symbol.for("nodejs.util.inspect.custom")] = Wt.prototype.inspect), [{
    name: function name(t) {
      return "".concat(t, "Edge");
    },
    generateKey: !0
  }, {
    name: function name(t) {
      return "".concat(t, "DirectedEdge");
    },
    generateKey: !0,
    type: "directed"
  }, {
    name: function name(t) {
      return "".concat(t, "UndirectedEdge");
    },
    generateKey: !0,
    type: "undirected"
  }, {
    name: function name(t) {
      return "".concat(t, "EdgeWithKey");
    }
  }, {
    name: function name(t) {
      return "".concat(t, "DirectedEdgeWithKey");
    },
    type: "directed"
  }, {
    name: function name(t) {
      return "".concat(t, "UndirectedEdgeWithKey");
    },
    type: "undirected"
  }].forEach(function (t) {
    ["add", "merge", "update"].forEach(function (e) {
      var n = t.name(e),
          r = "add" === e ? Ct : zt;
      t.generateKey ? Wt.prototype[n] = function (i, o, a) {
        return r(this, n, !0, "undirected" === (t.type || this.type), null, i, o, a, "update" === e);
      } : Wt.prototype[n] = function (i, o, a, u) {
        return r(this, n, !1, "undirected" === (t.type || this.type), i, o, a, u, "update" === e);
      };
    });
  }), function (t) {
    X.forEach(function (e) {
      var n = e.name,
          r = e.attacher;
      r(t, n("Node"), 0), r(t, n("Source"), 1), r(t, n("Target"), 2), r(t, n("Opposite"), 3);
    });
  }(Wt), function (t) {
    Z.forEach(function (e) {
      var n = e.name,
          r = e.attacher;
      r(t, n("Edge"), "mixed"), r(t, n("DirectedEdge"), "directed"), r(t, n("UndirectedEdge"), "undirected");
    });
  }(Wt), function (t) {
    nt.forEach(function (e) {
      !function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction;

        t.prototype[n] = function (t, e) {
          if ("mixed" !== r && "mixed" !== this.type && r !== this.type) return [];
          if (!arguments.length) return st(this, r);

          if (1 === arguments.length) {
            t = "" + t;

            var o = this._nodes.get(t);

            if (void 0 === o) throw new I("Graph.".concat(n, ': could not find the "').concat(t, '" node in the graph.'));
            return ft(this.multi, "mixed" === r ? this.type : r, i, o);
          }

          if (2 === arguments.length) {
            t = "" + t, e = "" + e;

            var a = this._nodes.get(t);

            if (!a) throw new I("Graph.".concat(n, ':  could not find the "').concat(t, '" source node in the graph.'));
            if (!this._nodes.has(e)) throw new I("Graph.".concat(n, ':  could not find the "').concat(e, '" target node in the graph.'));
            return yt(r, this.multi, i, a, e);
          }

          throw new F("Graph.".concat(n, ": too many arguments (expecting 0, 1 or 2 and got ").concat(arguments.length, ")."));
        };
      }(t, e), function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction,
            o = "forEach" + n[0].toUpperCase() + n.slice(1, -1);

        t.prototype[o] = function (t, e, n) {
          if ("mixed" === r || "mixed" === this.type || r === this.type) {
            if (1 === arguments.length) return dt(!1, this, r, n = t);

            if (2 === arguments.length) {
              t = "" + t, n = e;

              var a = this._nodes.get(t);

              if (void 0 === a) throw new I("Graph.".concat(o, ': could not find the "').concat(t, '" node in the graph.'));
              return pt(!1, this.multi, "mixed" === r ? this.type : r, i, a, n);
            }

            if (3 === arguments.length) {
              t = "" + t, e = "" + e;

              var u = this._nodes.get(t);

              if (!u) throw new I("Graph.".concat(o, ':  could not find the "').concat(t, '" source node in the graph.'));
              if (!this._nodes.has(e)) throw new I("Graph.".concat(o, ':  could not find the "').concat(e, '" target node in the graph.'));
              return gt(!1, r, this.multi, i, u, e, n);
            }

            throw new F("Graph.".concat(o, ": too many arguments (expecting 1, 2 or 3 and got ").concat(arguments.length, ")."));
          }
        };

        var a = "map" + n[0].toUpperCase() + n.slice(1);

        t.prototype[a] = function () {
          var t,
              e = Array.prototype.slice.call(arguments),
              n = e.pop();

          if (0 === e.length) {
            var i = 0;
            "directed" !== r && (i += this.undirectedSize), "undirected" !== r && (i += this.directedSize), t = new Array(i);
            var a = 0;
            e.push(function (e, r, i, o, u, c, s) {
              t[a++] = n(e, r, i, o, u, c, s);
            });
          } else t = [], e.push(function (e, r, i, o, a, u, c) {
            t.push(n(e, r, i, o, a, u, c));
          });

          return this[o].apply(this, e), t;
        };

        var u = "filter" + n[0].toUpperCase() + n.slice(1);

        t.prototype[u] = function () {
          var t = Array.prototype.slice.call(arguments),
              e = t.pop(),
              n = [];
          return t.push(function (t, r, i, o, a, u, c) {
            e(t, r, i, o, a, u, c) && n.push(t);
          }), this[o].apply(this, t), n;
        };

        var c = "reduce" + n[0].toUpperCase() + n.slice(1);

        t.prototype[c] = function () {
          var t,
              e,
              n = Array.prototype.slice.call(arguments);
          if (n.length < 2 || n.length > 4) throw new F("Graph.".concat(c, ": invalid number of arguments (expecting 2, 3 or 4 and got ").concat(n.length, ")."));
          if ("function" == typeof n[n.length - 1] && "function" != typeof n[n.length - 2]) throw new F("Graph.".concat(c, ": missing initial value. You must provide it because the callback takes more than one argument and we cannot infer the initial value from the first iteration, as you could with a simple array."));
          2 === n.length ? (t = n[0], e = n[1], n = []) : 3 === n.length ? (t = n[1], e = n[2], n = [n[0]]) : 4 === n.length && (t = n[2], e = n[3], n = [n[0], n[1]]);
          var r = e;
          return n.push(function (e, n, i, o, a, u, c) {
            r = t(r, e, n, i, o, a, u, c);
          }), this[o].apply(this, n), r;
        };
      }(t, e), function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction,
            o = "find" + n[0].toUpperCase() + n.slice(1, -1);

        t.prototype[o] = function (t, e, n) {
          if ("mixed" !== r && "mixed" !== this.type && r !== this.type) return !1;
          if (1 === arguments.length) return dt(!0, this, r, n = t);

          if (2 === arguments.length) {
            t = "" + t, n = e;

            var a = this._nodes.get(t);

            if (void 0 === a) throw new I("Graph.".concat(o, ': could not find the "').concat(t, '" node in the graph.'));
            return pt(!0, this.multi, "mixed" === r ? this.type : r, i, a, n);
          }

          if (3 === arguments.length) {
            t = "" + t, e = "" + e;

            var u = this._nodes.get(t);

            if (!u) throw new I("Graph.".concat(o, ':  could not find the "').concat(t, '" source node in the graph.'));
            if (!this._nodes.has(e)) throw new I("Graph.".concat(o, ':  could not find the "').concat(e, '" target node in the graph.'));
            return gt(!0, r, this.multi, i, u, e, n);
          }

          throw new F("Graph.".concat(o, ": too many arguments (expecting 1, 2 or 3 and got ").concat(arguments.length, ")."));
        };

        var a = "some" + n[0].toUpperCase() + n.slice(1, -1);

        t.prototype[a] = function () {
          var t = Array.prototype.slice.call(arguments),
              e = t.pop();
          return t.push(function (t, n, r, i, o, a, u) {
            return e(t, n, r, i, o, a, u);
          }), !!this[o].apply(this, t);
        };

        var u = "every" + n[0].toUpperCase() + n.slice(1, -1);

        t.prototype[u] = function () {
          var t = Array.prototype.slice.call(arguments),
              e = t.pop();
          return t.push(function (t, n, r, i, o, a, u) {
            return !e(t, n, r, i, o, a, u);
          }), !this[o].apply(this, t);
        };
      }(t, e), function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction,
            o = n.slice(0, -1) + "Entries";

        t.prototype[o] = function (t, e) {
          if ("mixed" !== r && "mixed" !== this.type && r !== this.type) return O.empty();
          if (!arguments.length) return ht(this, r);

          if (1 === arguments.length) {
            t = "" + t;

            var n = this._nodes.get(t);

            if (!n) throw new I("Graph.".concat(o, ': could not find the "').concat(t, '" node in the graph.'));
            return lt(r, i, n);
          }

          if (2 === arguments.length) {
            t = "" + t, e = "" + e;

            var a = this._nodes.get(t);

            if (!a) throw new I("Graph.".concat(o, ':  could not find the "').concat(t, '" source node in the graph.'));
            if (!this._nodes.has(e)) throw new I("Graph.".concat(o, ':  could not find the "').concat(e, '" target node in the graph.'));
            return wt(r, i, a, e);
          }

          throw new F("Graph.".concat(o, ": too many arguments (expecting 0, 1 or 2 and got ").concat(arguments.length, ")."));
        };
      }(t, e);
    });
  }(Wt), function (t) {
    vt.forEach(function (e) {
      Gt(t, e), function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction,
            o = "forEach" + n[0].toUpperCase() + n.slice(1, -1);

        t.prototype[o] = function (t, e) {
          if ("mixed" === r || "mixed" === this.type || r === this.type) {
            t = "" + t;

            var n = this._nodes.get(t);

            if (void 0 === n) throw new I("Graph.".concat(o, ': could not find the "').concat(t, '" node in the graph.'));
            kt(!1, "mixed" === r ? this.type : r, i, n, e);
          }
        };

        var a = "map" + n[0].toUpperCase() + n.slice(1);

        t.prototype[a] = function (t, e) {
          var n = [];
          return this[o](t, function (t, r) {
            n.push(e(t, r));
          }), n;
        };

        var u = "filter" + n[0].toUpperCase() + n.slice(1);

        t.prototype[u] = function (t, e) {
          var n = [];
          return this[o](t, function (t, r) {
            e(t, r) && n.push(t);
          }), n;
        };

        var c = "reduce" + n[0].toUpperCase() + n.slice(1);

        t.prototype[c] = function (t, e, n) {
          if (arguments.length < 3) throw new F("Graph.".concat(c, ": missing initial value. You must provide it because the callback takes more than one argument and we cannot infer the initial value from the first iteration, as you could with a simple array."));
          var r = n;
          return this[o](t, function (t, n) {
            r = e(r, t, n);
          }), r;
        };
      }(t, e), function (t, e) {
        var n = e.name,
            r = e.type,
            i = e.direction,
            o = n[0].toUpperCase() + n.slice(1, -1),
            a = "find" + o;

        t.prototype[a] = function (t, e) {
          if ("mixed" === r || "mixed" === this.type || r === this.type) {
            t = "" + t;

            var n = this._nodes.get(t);

            if (void 0 === n) throw new I("Graph.".concat(a, ': could not find the "').concat(t, '" node in the graph.'));
            return kt(!0, "mixed" === r ? this.type : r, i, n, e);
          }
        };

        var u = "some" + o;

        t.prototype[u] = function (t, e) {
          return !!this[a](t, e);
        };

        var c = "every" + o;

        t.prototype[c] = function (t, e) {
          return !this[a](t, function (t, n) {
            return !e(t, n);
          });
        };
      }(t, e), xt(t, e);
    });
  }(Wt);

  var Pt = function (t) {
    function n(e) {
      var n = c({
        type: "directed"
      }, e);
      if ("multi" in n && !1 !== n.multi) throw new F("DirectedGraph.from: inconsistent indication that the graph should be multi in given options!");
      if ("directed" !== n.type) throw new F('DirectedGraph.from: inconsistent "' + n.type + '" type in given options!');
      return t.call(this, n) || this;
    }

    return e(n, t), n;
  }(Wt),
      Rt = function (t) {
    function n(e) {
      var n = c({
        type: "undirected"
      }, e);
      if ("multi" in n && !1 !== n.multi) throw new F("UndirectedGraph.from: inconsistent indication that the graph should be multi in given options!");
      if ("undirected" !== n.type) throw new F('UndirectedGraph.from: inconsistent "' + n.type + '" type in given options!');
      return t.call(this, n) || this;
    }

    return e(n, t), n;
  }(Wt),
      Kt = function (t) {
    function n(e) {
      var n = c({
        multi: !0
      }, e);
      if ("multi" in n && !0 !== n.multi) throw new F("MultiGraph.from: inconsistent indication that the graph should be simple in given options!");
      return t.call(this, n) || this;
    }

    return e(n, t), n;
  }(Wt),
      Tt = function (t) {
    function n(e) {
      var n = c({
        type: "directed",
        multi: !0
      }, e);
      if ("multi" in n && !0 !== n.multi) throw new F("MultiDirectedGraph.from: inconsistent indication that the graph should be simple in given options!");
      if ("directed" !== n.type) throw new F('MultiDirectedGraph.from: inconsistent "' + n.type + '" type in given options!');
      return t.call(this, n) || this;
    }

    return e(n, t), n;
  }(Wt),
      Bt = function (t) {
    function n(e) {
      var n = c({
        type: "undirected",
        multi: !0
      }, e);
      if ("multi" in n && !0 !== n.multi) throw new F("MultiUndirectedGraph.from: inconsistent indication that the graph should be simple in given options!");
      if ("undirected" !== n.type) throw new F('MultiUndirectedGraph.from: inconsistent "' + n.type + '" type in given options!');
      return t.call(this, n) || this;
    }

    return e(n, t), n;
  }(Wt);

  function Ft(t) {
    t.from = function (e, n) {
      var r = c({}, e.options, n),
          i = new t(r);
      return i.import(e), i;
    };
  }

  return Ft(Wt), Ft(Pt), Ft(Rt), Ft(Kt), Ft(Tt), Ft(Bt), Wt.Graph = Wt, Wt.DirectedGraph = Pt, Wt.UndirectedGraph = Rt, Wt.MultiGraph = Kt, Wt.MultiDirectedGraph = Tt, Wt.MultiUndirectedGraph = Bt, Wt.InvalidArgumentsGraphError = F, Wt.NotFoundGraphError = I, Wt.UsageGraphError = Y, Wt;
});